const CDN_PATH = `${process.env.CDN_BASE_PATH}/`;
const FILE_SEPARATOR = "/";

/**
 * @param path
 * @param type
 * @returns {string}
 */
export function cache(path: string, type = "true"): string {
    // Add cache parameter to url
    let results = path;

    const p = path.split(FILE_SEPARATOR);
    let last = p.pop();

    if(typeof last === "undefined") {
        last = "";
    }

    let prefix = "?";

    if(last.includes(prefix)) {
        prefix = "&";
    }

    results += prefix + `cache=${type}`;

    return results;
}

/**
 * @return {string}
 */
export default function CDN(path: string, cacheFile = true): string {
    let results = "";

    results += CDN_PATH;

    if(CDN_PATH.slice(-1) !== FILE_SEPARATOR) {
        results += FILE_SEPARATOR;
    }

    const file = cacheFile ? cache(path) : path;

    if(file.charAt(0) === FILE_SEPARATOR) {
        results += file.slice(1);
    } else {
        results += file;
    }

    return results;
}
